import React from 'react';
import {Button, Dropdown, Menu} from "antd";
import {EllipsisOutlined} from "@ant-design/icons";
import {pp} from "../utils";

export default ({ action, title, actions, size="small", defAction, ...props}) => {
  actions = actions || [action]

  let onClick = (key) => {
    let a = actions[key][1];

    if (_.isString(a))
      defAction(a, actions[key][2]);
    else
      a();
  }

  let menu = <Menu>
    {actions.map((a, i) => <Menu.Item key={i} onClick={() => onClick(i)}>{a[0]}</Menu.Item>)}
  </Menu>

  return <Dropdown overlay={menu} trigger="click" onSelect={onClick} {...props}>
    <Button size={size}>{title || <EllipsisOutlined /> }</Button>
  </Dropdown>
}